const styles = () => ({
  root: {
    backgroundColor: "inherit",
    position: "relative",
    zIndex: 0,
  },
});

export default styles;
